import React, { FC, useEffect } from 'react'

interface PropsType {
}

const Widget: FC<PropsType> = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://widget-view.dmm.co.jp/js/placement.js"
    script.className = "dmm-widget-scripts"
    script.dataset.id = 'e0f9b8cf4852ff8122f3b1fc315a92d5'
    script.async = true

    const widget = document.getElementById('widget')!
    widget.appendChild(script)
    
  }, [])
 
  return (
    <div id="widget">
      <ins
        className="dmm-widget-placement"
        data-id="e0f9b8cf4852ff8122f3b1fc315a92d5"
        style={{background:"transparent"}}>
      </ins>
    </div>
  )
}

export default Widget
